// extracted by mini-css-extract-plugin
module.exports = {"container":"Title_container__rVqgv","titleWrapper":"Title_titleWrapper__zDdAC","resultCount":"Title_resultCount__jT8t_","bracket":"Title_bracket__uyd3G"};